// packages/0-foundation/core.module/src/v1/_universal/lvl_1/logger.part/utils/_parts/lvl_2/mask-sensitive-data.util.ts

const SENSITIVE_KEY_PATTERN = /pass|token|secret|authoriz|cookie|email|phone|card/i;

export function maskSensitiveData(data: unknown): unknown {
  if (Array.isArray(data)) return data.map(maskSensitiveData);
  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        SENSITIVE_KEY_PATTERN.test(key) ? "***" : maskSensitiveData(value),
      ]),
    );
  }
  return data;
}
